<div class="videoWrapper">
  <iframe [src]='safeUrl' width="640" height="360" style="margin-top: 2px; margin-bottom: 3px;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
</div>
<mat-icon class="close-icon" (click)="close()">close</mat-icon>